import moment from 'moment/moment';
import React, {useEffect, useState} from 'react';
import {
   StatusBar,
   StyleSheet,
   Text,
   View,
   Animated,
   Dimensions,
   TouchableOpacity,
   ActivityIndicator,
   Platform,
} from 'react-native';
import {
   ALLCOURSE,
   appBackground,
   base100,
   BROUS,
   DASHBOARD,
   HIDELEGACY,
   INSESSION,
   MYTRAINING,
   norcatAppColor,
   RECENT,
   redirectToBrowser,
   white,
   FONT_FAMILY_REGULAR,
   GET_DASHBOARD_DATA,
   getNorcatId,
   getQRCode,
   isNewAPI,
   COURSE_ROOT_ITEM,
   isWeb,
   isWindows,
   getFistNameAndLastName,
   getProfileImage,
   ActivityLoaderColor,
   COURSE_STATUS_0_ENR,
   COURSE_STATUS_1_SES,
   REFRESH_DASHBOARD,
   isiOS,
} from '../../utils/utils';
import {storeAppData} from '../../utils/preference';
import DashboardHeaderLandsacap from './DashboardHeaderLandsacap';
import DashboardLeftView from './DashboardLeftView';
import DashboardHeader from './DashboardHeader';
import {ApplicationHeader} from '../../utils/application_header';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {CourseList} from './course_list';
import DashboardRightPanel from './DashboardRightPanel';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {useDispatch, useSelector} from 'react-redux';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import Orientation from 'react-native-orientation-locker';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import logger from '../../utils/logger';
import {setIsEnrolledPageReload} from '../../redux/slices/EnrolledCourseDataSlice';
import {setIsTrPageReload} from '../../redux/slices/MyTrainingRecordSlice';
import {
   selectDashboardRefresh,
   selectDashboardRefreshWindows,
   setIsDashboardRefreshRequired,
   setIsDashboardRefreshRequiredWindows,
} from '../../redux/slices/DashboardRefreshSlice';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import {
   selectUserTrainingRecord,
   setUserTrainingRecord,
} from '../../redux/slices/UserTrainingRecordSlice';

import {UseSelector} from 'react-redux/es/hooks/useSelector';

const DashboardScreen = () => {
   const navigation = useNavigation();
   // const [authData, setAuthData] = useState({});
   const [showView, setShowView] = useState(false);
   const [filterCourses, setSetFilterCoursed] = useState(
      'Viewing All Enrolled Courses',
   );
   const RECENT_COURSE_DAY_DIFFERENCE = 30;
   const [currentCourseFilterTab, setCurrentCourseFilterTab] =
      useState(ALLCOURSE);
   const [searchText, setSearchText] = useState('');
   const [courseList, setCourseList] = useState([]);
   const [tempCourseList, setTempCourseList] = useState([]);
   const [animatedValue] = useState(new Animated.Value(-2000));
   const {width, height} = Dimensions.get('window');
   const isLandscapemode = useSelector(selectScreenOrientation);
   const authData = useSelector(selectAuthData);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const isEmpty = courseList?.length === 0 && !isApiLoading;
   const dispatch = useDispatch();
   const isScreenFocused = useIsFocused();
   const isRefreshRequired = useSelector(selectDashboardRefresh);
   const isDashboardRefreshRequiredWindows = useSelector(
      selectDashboardRefreshWindows,
   );
   const windowHeight = window.innerHeight ?? Dimensions.get('window').height;
   const enrolledCoursesData = useSelector(selectUserTrainingRecord);
   const [selectedFilterTab, setSelectedFilterTab] = useState(ALLCOURSE);
   const deviceHeightForWeb =
      windowHeight < 780
         ? // Medium size Desktop/Tablet
           windowHeight < 680
            ? windowHeight < 600
               ? windowHeight * 0.27
               : windowHeight * 0.325
            : windowHeight < 701
            ? windowHeight * 0.35
            : windowHeight < 750
            ? windowHeight * 0.415
            : windowHeight * 0.367
         : // Large size Desktop
         windowHeight > 1000
         ? windowHeight * 0.5
         : windowHeight * 0.45;
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const needToShowRightPanel = !isWeb
      ? true
      : windowDimensions.width > 800
      ? true
      : false;
   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (isLandscapemode) {
            Orientation.lockToLandscape();
         } else {
            Orientation.lockToPortrait();
         }
         if (Platform.OS === 'windows') {
            dispatch(setIsEnrolledPageReload(true));
            dispatch(setIsTrPageReload(true));
         }

         if (isDashboardRefreshRequiredWindows && isWindows) {
            isNewAPI
               ? handleNewDashboardAPI({isLoadingVisible: true})
               : handleDashboardAPI({isLoadingVisible: true});
            dispatch(setIsDashboardRefreshRequiredWindows(false));
         } else if (isWindows) {
            setCourseList(enrolledCoursesData);
            setTempCourseList(enrolledCoursesData);
         } else {
            isNewAPI
               ? handleNewDashboardAPI({isLoadingVisible: true})
               : handleDashboardAPI({isLoadingVisible: true});
            dispatch(setIsDashboardRefreshRequiredWindows(false));
         }
      }
   }, []);
   useEffect(() => {
      logger(
         'REFRESH SCREEN: REQUIRED :: ',
         isScreenFocused && isRefreshRequired,
      );
      if (isScreenFocused && isRefreshRequired) {
         isNewAPI
            ? handleNewDashboardAPI({isLoadingVisible: false})
            : handleDashboardAPI({isLoadingVisible: false});
      }
   }, [isScreenFocused, isRefreshRequired]);

   useEffect(() => {
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      Dimensions.addEventListener('change', handleResize);
      return () => {
         Dimensions.removeEventListener('change', handleResize);
      };
   }, [windowDimensions]);
   function handleDashboardAPI({isLoadingVisible}) {
      (async () => {
         setCourseList(authData.enrolledCourses);
         setTempCourseList(authData.enrolledCourses);
      })();
      dispatch(setIsDashboardRefreshRequired(false));
   }
   function handleNewDashboardAPI({isLoadingVisible}) {
      (async () => {
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: authData.EmployeeKey,
            }),
         };
         logger('isLoadingVisible:: ', isLoadingVisible);
         setIsApiLoading(isLoadingVisible);
         apiPostRequest({url: GET_DASHBOARD_DATA, parms: reqParms})
            .then(res => {
               setIsApiLoading(false);
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string'
               ) {
                  logger('dashBoardData::', res);
                  //Filter the cousers of version 9
                  let filteredCourses =
                     res.UserTrainingEnrolledRecordsList.filter(
                        course => course.courseVersion != '9',
                     );
                  setTempCourseList(filteredCourses);
                  if (selectedFilterTab === RECENT) {
                     const list = filterRecentEnrolledData();
                     setCourseList(list);
                  } else {
                     setCourseList(filteredCourses);
                  }
                  const userRecord = {userTrainingRecord: filteredCourses};
                  dispatch(setUserTrainingRecord(userRecord));
               } else {
                  if (isWeb) {
                     showTokenExpireAlertWeb(res);
                  } else {
                     alert(res);
                  }
               }
               dispatch(setIsDashboardRefreshRequired(false));
            })
            .catch(error => {
               logger('error::', error);
            });
      })();
   }
   const handlePress = () => {
      logger('menu');
      setShowView(!showView);
      Animated.timing(animatedValue, {
         toValue: showView ? -1000 : 0,
         duration: 300,
         useNativeDriver: false,
      }).start();
   };

   const hanleDrawerNavigation = id => {
      const rowSelected = parseInt(id, 10);
      switch (rowSelected) {
         case 1:
            logger('Dismiss drawer');
            break;
         case 2:
            // Navigate to My Tranings
            logger('Navigate to My Tranings');
            navigation.navigate('MyTraningScreen');
            break;
         case 3:
            // Navigate to Browse Courses
            logger('Navigate to Browse Courses');
            navigation.navigate('BrowsesCoursesScreen');

            break;
         case 4:
            // Navigate to Logout
            logger('Navigate to Logout');
            navigation.navigate('LogoutScreen');
            break;
         default:
      }
   };
   function filterRecentEnrolledData() {
      const list = tempCourseList
         .filter(
            data =>
               data.courseStatus === COURSE_STATUS_0_ENR ||
               data.courseStatus === COURSE_STATUS_1_SES,
         )
         .sort((a, b) =>
            a.coursename
               .toLowerCase()
               .localeCompare(b.coursename.toLowerCase(), undefined, {
                  sensitivity: 'base',
               }),
         );
      return list;
   }
   function filterList(filterRef) {
      if (tempCourseList === 'undefined' || tempCourseList.length === 0) {
         return;
      }
      setCurrentCourseFilterTab(filterRef);
      logger('templist: ', tempCourseList);
      if (filterRef === ALLCOURSE) {
         setSelectedFilterTab(filterRef);

         setSetFilterCoursed('Viewing All Enrolled Courses');
         setCourseList(tempCourseList);
      } else if (filterRef === RECENT) {
         setSelectedFilterTab(filterRef);

         setSetFilterCoursed('Viewing Recently Visited Courses');

         const list = filterRecentEnrolledData();
         setCourseList(list);
      } else if (filterRef === INSESSION) {
         setSetFilterCoursed('Viewing In-Session Courses');

         const list = tempCourseList.filter(
            data => data.courseStatus === '1 -SES',
         );
         setCourseList(list);
      } else if (filterRef === HIDELEGACY) {
         setSetFilterCoursed('Viewing Hide Legacy Courses');

         const list = tempCourseList.filter(
            data => data.courseVersion === '10',
         );
         setCourseList(list);
      } else if (filterRef === REFRESH_DASHBOARD) {
         dispatch(setIsDashboardRefreshRequired(true));
      }
   }

   const handlePressWhenDrawerVisible = () => {
      if (showView) {
         handlePress();
      }
   };
   function searchFilterCourseList(text) {
      if (text === '') {
         if (currentCourseFilterTab === ALLCOURSE) {
            setCourseList(tempCourseList);
         } else {
            const recentAllList = filterRecentEnrolledData();
            setCourseList(recentAllList);
         }
      } else {
         let filterTemListTabData;
         if (currentCourseFilterTab === ALLCOURSE) {
            filterTemListTabData = tempCourseList;
         } else {
            filterTemListTabData = filterRecentEnrolledData();
         }
         const courseList = filterTemListTabData.filter(function (item) {
            // Applying filter for the inserted text in search bar
            const itemData = item.coursename
               ? item.coursename.toUpperCase()
               : ''.toUpperCase();
            const textData = text.toUpperCase();
            return itemData.indexOf(textData) > -1;
         });
         setCourseList(courseList);
      }
   }
   const isMobileWebView = Dimensions.get('window').width < 781;
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const renderActivityIndicator = () => {
      if (isApiLoading) {
         return (
            <View
               style={{
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
               }}>
               <ActivityIndicator
                  size="large"
                  color={ActivityLoaderColor}
                  style={[
                     {
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right:
                           Platform.OS === 'web'
                              ? isMobileWebView
                                 ? 0
                                 : 0
                              : 0,
                     },
                     isiOS && {zIndex: 1},
                  ]}
               />
            </View>
         );
      }
      return null;
   };
   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     minHeight: '100vh',
                     height: '100%',
                     overflowY: isLandscapemode ? 'hidden' : null,
                  },
               }),
            },
         ]}>
         {/*Animation view and Drawer menu only for portrait mobile app*/}

         {!isLandscapemode ? (
            <Animated.View
               style={[
                  {
                     backgroundColor: 'transparent',
                     width: '75%',
                     flex: 1,
                     height: '100%',
                     position: 'absolute',
                     left: animatedValue,
                     zIndex: 1000,
                     ...Platform.select({
                        web: {
                           width: '75vw',
                        },
                     }),
                  },
               ]}>
               <DashboardLeftView
                  userName={getFistNameAndLastName(authData)}
                  profileImage={getProfileImage(authData)}
                  onMenuClick={() => {
                     handlePress();
                  }}
                  onRowSelected={id => {
                     handlePress();
                     hanleDrawerNavigation(id);
                  }}
                  openProfileScreen={() => {
                     handlePress();
                     navigation.navigate('ProfileScreen');
                  }}
               />
            </Animated.View>
         ) : (
            <Landscap_Application_Header
               authData={authData}
               selectedTab={DASHBOARD}
               onProfileClick={event => {
                  // setAnchorView({
                  //    x: event.nativeEvent.pageX - 170,
                  //    y: event.nativeEvent.pageY + 24,
                  // });
                  // setPopoverVisible(true);
               }}
               onTopMenuClick={value => {
                  if (value === DASHBOARD) {
                     navigation.navigate('DashboardScreen');
                  } else if (value === MYTRAINING) {
                     navigation.navigate('MyTraningScreen');
                  } else if (value === BROUS) {
                     logger('Browse Screen');
                     navigation.navigate('BrowsesCoursesScreen');
                  }
               }}
               dataSource={['View Profile', 'Edit Profile', 'Logout']}
            />
         )}

         {/* Check of HeaderView for Mobile(ApplicationHeader) and others platform(DashboardHeaderLandsacap)*/}
         {!isLandscapemode ? (
            <ApplicationHeader
               onDrawbarPress={() => {
                  // To do : not working click event
                  logger('menu pressed');
                  handlePress();
               }}
            />
         ) : (
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  ...Platform.select({
                     web: {
                        maxHeight: isLandscapemode ? '92.5vh' : null,
                     },
                  }),
               }}>
               <View
                  style={{
                     flex: 1,
                  }}>
                  <DashboardHeaderLandsacap
                     authData={authData}
                     showEnrolledCourses={
                        isNewAPI ? courseList : authData.enrolledCourses
                     }
                     title="Dashboard"
                     subtitle={filterCourses}
                     icon={require('../../assets/dashboard.png')}
                     showCourses={true}
                     showSearchView={true}
                     showFilterTabs={true}
                     showRecordTabs={false}
                     showRefreshIcon={true}
                     showFooter={true}
                     onQrClick={() => {
                        navigation.navigate('QRAndBarcodeScreen', {
                           norcatID: getNorcatId(authData),
                           qrID: getQRCode(authData), //authData.QRID,
                        });
                     }}
                     onFilterClick={filterRef => {
                        filterList(filterRef);
                     }}
                     onSearch={text => {
                        logger('courseSearch::', text);
                        setSearchText(text);
                        searchFilterCourseList(text);
                     }}
                     onClearText={() => {
                        if (currentCourseFilterTab === ALLCOURSE) {
                           setCourseList(tempCourseList);
                        } else {
                           setCourseList(filterRecentEnrolledData());
                        }
                     }}
                     isDashboardRefresh={isRefreshRequired}
                  />
                  <View
                     style={{
                        flex: 1,
                     }}>
                     {isEmpty ? (
                        <View
                           style={{
                              flex: 1,
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Text
                              style={{
                                 color: 'black',
                                 alignSelf: 'center',
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 textAlignVertical: 'center',
                                 alignContent: 'center',
                              }}>
                              NO COURSES AVAILABLE
                           </Text>
                        </View>
                     ) : (
                        <View style={{flex: 1}}>
                           <CourseList
                              courseListData={courseList}
                              onSingleItemClick={item => {
                                 onHandleCourseClick(item);
                              }}
                           />
                           {renderActivityIndicator()}
                        </View>
                     )}
                  </View>
               </View>
               {needToShowRightPanel && (
                  <View
                     style={{
                        flex: 0.4,
                        ...Platform.select({
                           web: {
                              flex: isLandscapemode ? null : 0.4,
                              width: isLandscapemode ? '30%' : null,
                              height: isLandscapemode ? '90vh' : null,
                              minWidth: isLandscapemode ? '30%' : null,
                           },
                        }),
                     }}>
                     <DashboardRightPanel
                        authData={authData}
                        showPercentageData={
                           isNewAPI ? tempCourseList : authData
                        }
                        showName={true}
                        height={deviceHeightForWeb}
                        showProgressView={true}
                        onQrClick={() => {
                           navigation.navigate('QRAndBarcodeScreen', {
                              norcatID: getNorcatId(authData),
                              qrID: getQRCode(authData), //authData.QRID,
                           });
                        }}
                     />
                  </View>
               )}
            </View>
         )}
         <StatusBar backgroundColor={norcatAppColor} />

         {/*DashboardHeader view portrait mobile app*/}
         {!isLandscapemode ? (
            <View style={{flex: 1}}>
               <DashboardHeader
                  authData={authData}
                  showPercentageData={isNewAPI ? courseList : authData}
                  showEnrolledCourses={
                     isNewAPI ? courseList : authData.enrolledCourses
                  }
                  showProgressView={true}
                  subTitle={filterCourses}
                  onProfileClick={() => {
                     navigation.navigate('ProfileScreen');
                  }}
                  onFilterClick={filterRef => {
                     filterList(filterRef);
                  }}
                  onQrClick={() => {
                     navigation.navigate('QRAndBarcodeScreen', {
                        norcatID: getNorcatId(authData),
                        qrID: getQRCode(authData), //authData.QRID,
                     });
                  }}
                  isDashboardRefresh={isRefreshRequired}
               />
               {/* Portrait */}
               <View style={{flex: 1}}>
                  {isEmpty ? (
                     <Text
                        style={{
                           color: 'black',
                           height: '100%',
                           alignSelf: 'center',
                           justifyContent: 'center',
                           alignItems: 'center',
                           textAlignVertical: 'center',
                           alignContent: 'center',
                        }}>
                        NO COURSES AVAILABLE
                     </Text>
                  ) : (
                     <CourseList
                        courseListData={courseList}
                        onSingleItemClick={item => {
                           onHandleCourseClick(item);
                        }}
                     />
                  )}
               </View>
               {isApiLoading && (
                  <ActivityIndicator
                     size="large"
                     color={ActivityLoaderColor}
                     style={[
                        {
                           position: 'absolute',
                           top: 100,
                           bottom: 0,
                           left: 0,
                           right:
                              Platform.OS === 'web'
                                 ? isMobileWebView
                                    ? 0
                                    : 0
                                 : 0,
                        },
                        isiOS && {zIndex: 1},
                     ]}
                  />
               )}
            </View>
         ) : null}

         {showView && !isLandscapemode ? (
            <TouchableOpacity
               style={[styles.transParentView, {height: '100%'}]}
               onPress={() => {
                  handlePress();
               }}>
               <View>
                  {/*This view is being used for showing transparent view on opening of menu drawyer */}
               </View>
            </TouchableOpacity>
         ) : null}
      </View>
   );
   function onHandleCourseClick(item) {
      if (item.courseVersion === '10' || item.courseVersion === 10) {
         const singleCourseItem = JSON.stringify(item);
         storeAppData(COURSE_ROOT_ITEM, singleCourseItem);
         logger(JSON.stringify(item, null, 2));
         navigation.navigate('courseLoading', {courseData: item});
      } else {
         //@ADK - Now leaving myIBT (Flash Legacy)
         const myURL =
            'https://ibt.norcattraining.com/xcStartApp9.asp?usr=' +
            item.loginid +
            '&psd=' +
            item.pid;
         redirectToBrowser({url: myURL});
         logger('OPEN: ' + myURL);
      }
   }
};

const styles = StyleSheet.create({
   container: {flex: 1, backgroundColor: white},
   inputStyle: {
      width: '100%',
      height: 40,
      backgroundColor: white,
      marginTop: 8,
      borderWidth: 1,
      paddingHorizontal: 14,
      borderColor: '#AFBACA',
      borderRadius: 6,
      fontSize: 14,
      textAlignVertical: 'center',
      alignItems: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#3D4A5C',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'column',
   },
   transParentView: {
      backgroundColor: 'rgba(0,0,0,0.2)',
      width: '25%',
      flexDirection: 'row-reverse',
      alignSelf: 'flex-end',
      position: 'absolute',
      zIndex: 999,
   },
});

export default DashboardScreen;